import { render, staticRenderFns } from "./HeroFeaturedManager.vue?vue&type=template&id=c0cce3ba&"
import script from "./HeroFeaturedManager.vue?vue&type=script&lang=js&"
export * from "./HeroFeaturedManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports